import { render } from "./BackUP.vue?vue&type=template&id=6b2ce604&scoped=true"
import script from "./BackUP.vue?vue&type=script&lang=js"
export * from "./BackUP.vue?vue&type=script&lang=js"

import "./BackUP.vue?vue&type=style&index=0&id=6b2ce604&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2ce604"]])

export default __exports__